import { Refresh, Danger, Wifi } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import settings from "../settings";

interface AccessFailProps {
  errorMessage: string; // Thông báo lỗi cụ thể
  onRetry: () => void; // Callback để thử lại
  isLoading?: boolean;
}

const AccessFail: React.FC<AccessFailProps> = ({
  errorMessage,
  onRetry,
  isLoading,
}) => {
  const intl = useIntl();

  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    setShowAnimation(true);
  }, []);

  const handleRetry = () => {
    if (!isLoading) {
      onRetry();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      isLoading = false;
    }, 3000);
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, []);

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-gray-50 via-red-50 to-gray-100 flex items-center justify-center z-50 p-4">
      <div
        className={`bg-white/95 backdrop-blur-sm p-5 rounded-2xl shadow-md max-w-md w-full text-center border border-red-100 transform transition-all duration-500 ${
          showAnimation ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
      >
        {/* Icon Animation */}
        <div className="relative mb-5">
          <div className="relative bg-red-500 rounded-full p-4 mx-auto w-16 h-16 flex items-center justify-center">
            <Wifi className="w-8 h-8 text-white animate-pulse" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-800 mb-5">
          {intl.formatMessage({ id: "connect.failed" })}
        </h2>

        {/* Error Message */}
        <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-r-lg">
          <p className="text-gray-700 text-sm leading-relaxed">
            {errorMessage}
          </p>
        </div>

        {/* Retry Button */}
        <button
          onClick={handleRetry}
          disabled={isLoading}
          className={`w-full px-6 py-3 rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2 ${
            isLoading
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-gradient-to-r from-red-500 to-red-600 text-white hover:from-red-600 hover:to-red-700 hover:shadow-lg transform hover:scale-105 active:scale-95"
          }`}
        >
          {isLoading ? (
            <>
              <Refresh className="w-4 h-4 animate-spin" />
              <span>Đang thử lại...</span>
            </>
          ) : (
            <>
              <Refresh className="w-4 h-4" />
              <span>{intl.formatMessage({ id: "tryAgain" })}</span>
            </>
          )}
        </button>

        {/* Footer */}
        <footer className="mt-8 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            <Wifi className="w-4 h-4" />
            <span>
              Powered by{" "}
              <strong className="text-primary">{settings.poweredBy}</strong>
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AccessFail;
